<template>
  <DCard bordered class="card" :class="{'active-card': item.active}">
    <DCardSection class="section">
    <h5>Dashboard ID: {{ item.id }}</h5>
    <h5>Dashboard Name: {{ item.name }}</h5>
    <h5>Group ID: {{ item.groupId }}</h5>
    <h5>Institution ID: {{ item.institutionId }}</h5>
    <h5>Active: {{ item.active ? "yes" : "no" }}</h5>
    <div class="buttons" style="margin-top: 16px;">
      <router-link class="link" :to="'/admin/dashboard/' + item.id">
        <DButton color="primary" label="Open" class="btn-blue-margin" />
      </router-link>
      <router-link class="link" :to="'/admin/editor/' + item.id">
        <DButton color="primary" label="Edit" class="btn-blue-margin" />
      </router-link>
    </div>
  </DCardSection>
  </DCard>
</template>

<script>
import DButton from '@components/ui/DButton.vue'
import DCard from '@components/ui/DCard.vue'
import DCardSection from '@components/ui/DCardSection.vue'
export default {
  components: {
    DButton: DButton,
    DCard: DCard,
    DCardSection: DCardSection
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 16px;
  width: 500px;
}
.section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  color: black;
}

.link {
  display: block;
}

.btn-blue {
  background-color: #0077B6;
  color: white;
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  margin: 4px 2px;
  cursor: pointer;
}

.buttons {
  display: flex;
}

.btn-blue-margin {
  margin: 4px 2px;
  cursor: pointer;
}</style>
